import { dayjs } from "@carrotfertility/carotene-core"
import { MessageDescriptor, defineMessage } from "react-intl"

const DOB_VALIDATION_MESSAGES = {
  NOT_A_DATE: defineMessage({ defaultMessage: "Not a date" }),
  MUST_BE_18: defineMessage({ defaultMessage: "You must be at least 18 years old." }),
  MEMBER_MUST_BE_IN_PAST: defineMessage({ defaultMessage: "Date of birth must be in the past" }),
  PARTNER_MUST_BE_IN_PAST: defineMessage({ defaultMessage: "Your partner's date of birth must be in the past." })
}

export function validateMemberDOB(dateOfBirth: dayjs.Dayjs): MessageDescriptor | true {
  if (!dateOfBirth.isValid()) {
    return DOB_VALIDATION_MESSAGES.NOT_A_DATE
  }

  const yesterday = dayjs().subtract(1, "day")
  if (dateOfBirth.isAfter(yesterday)) {
    return DOB_VALIDATION_MESSAGES.MEMBER_MUST_BE_IN_PAST
  }

  const eighteenYearsAgo = dayjs().subtract(18, "years")
  if (dateOfBirth.isAfter(eighteenYearsAgo)) {
    return DOB_VALIDATION_MESSAGES.MUST_BE_18
  }

  return true
}

export function validatePartnerDOB(dateOfBirth: dayjs.Dayjs): MessageDescriptor | true {
  if (!dateOfBirth.isValid()) {
    return DOB_VALIDATION_MESSAGES.NOT_A_DATE
  }

  const yesterday = dayjs().subtract(1, "day")
  if (dateOfBirth.isAfter(yesterday)) {
    return DOB_VALIDATION_MESSAGES.PARTNER_MUST_BE_IN_PAST
  }

  return true
}
